import { queryOptions } from '@tanstack/react-query';
import api from '../api';
import {
  SubjectDetailsSchema,
  ProtocolListSchema,
  SubstancesListSchema,
  ProtocolPhasesListSchema,
  SubjectDetails,
  ProtocolList,
  SubstancesList,
  ProtocolPhasesList,
} from '@/api/schema/subject';

export type { SubjectDetails, ProtocolList, SubstancesList, ProtocolPhasesList };

export function getSubjectQueryOptions(id: string) {
  return queryOptions({
    queryKey: [ 'subjects', id ],
    queryFn: async () => {
      const response = await api.get(`subjects/${id}`);
      return SubjectDetailsSchema.parse(await response.json());
    },
  });
}

export function getProtocolsQueryOptions() {
  return queryOptions({
    queryKey: [ 'protocols' ],
    queryFn: async () => {
      const response = await api.get('protocols');
      return ProtocolListSchema.parse(await response.json());
    },
    staleTime: 1000 * 60 * 30,
  });
}

export function getSubstancesQueryOptions() {
  return queryOptions({
    queryKey: [ 'substances' ],
    queryFn: async () => {
      const response = await api.get('substances');
      return SubstancesListSchema.parse(await response.json());
    },
    staleTime: 1000 * 60 * 30,
  });
}

export function getProtocolPhasesQueryOptions({ subjectId }: { subjectId: string }) {
  return queryOptions({
    queryKey: [ 'subjects', subjectId, 'phases' ],
    queryFn: async () => {
      const response = await api.get(`subjects/${subjectId}/phases`);
      return ProtocolPhasesListSchema.parse(await response.json());
    },
  });
}
